/**
 * Possible positioning options
 * POSITION_TOPDOWN - log in window comes down from the top of page
 * POSITION_CARDS - which places the log in window lower down over the cards
 * @type {{className: string}}
 */
const POSITION_TOPDOWN = { className: '.RC-cardMandatoryLoginContainer_topdown' };
const POSITION_CARD = { className: '.RC-cardMandatoryLoginContainer_card' };

/** Tom Segal aka Pricewise
 * Visual themes, which can be applied to adjust component styling
 * @type {{name: string, className: string}}
 */
const THEME_PYMAN = { name: 'James Pyman aka Pycatcher', className: 'pyman' };
const THEME_SEGAL = { name: 'Tom Segal aka Pricewise', className: 'segal' };
const THEME_FIDLER = { name: 'Katherine Fidler, Features editor', className: 'fidler' };
const THEME_TWISTON_DAVIES = { name: 'Sam Twiston-Davies', className: 'twistonDavies' };
const THEME_SUCCESS = { name: null, className: 'success' };

const VARIANT_1 = 'VARIANT_1';
const VARIANT_2 = 'VARIANT_2';
const VARIANT_3 = 'VARIANT_3';
const VARIANT_4 = 'VARIANT_4';
const VARIANT_5 = 'VARIANT_5';
const VARIANT_6 = 'VARIANT_6';
const VARIANT_7 = 'VARIANT_7';
const VARIANT_8 = 'VARIANT_8';
const VARIANT_9 = 'VARIANT_9';
const VARIANT_10 = 'VARIANT_10';
const VARIANT_11 = 'VARIANT_11';
const VARIANT_12 = 'VARIANT_12';
const VARIANT_13 = 'VARIANT_13';
const VARIANT_14 = 'VARIANT_14';
const VARIANT_15 = 'VARIANT_15';
const VARIANT_16 = 'VARIANT_16';

export const POSITIONS = {
    POSITION_TOPDOWN,
    POSITION_CARD,
};

export const THEMES = {
    THEME_PYMAN,
    THEME_SEGAL,
    THEME_FIDLER,
    THEME_TWISTON_DAVIES,
    THEME_SUCCESS,
};

export const VARIANTS = {
    VARIANT_1,
    VARIANT_2,
    VARIANT_3,
    VARIANT_4,
    VARIANT_5,
    VARIANT_6,
    VARIANT_7,
    VARIANT_8,
    VARIANT_9,
    VARIANT_10,
    VARIANT_11,
    VARIANT_12,
    VARIANT_13,
    VARIANT_14,
    VARIANT_15,
    VARIANT_16,
};




// WEBPACK FOOTER //
// ./lib/js/modules/mandatoryLogin/mandatoryLogin.constants.js